module.exports = __webpack_public_path__ + "static/media/Arrow Down.77ac8a6b.svg";